import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

// GET pro core com o scaffold padrão dos adapters da roletinha (timeout de 10s
// + Accept JSON + throw em !ok) — os três adapters de leitura só mapeiam.
export async function rouletteApiGet(path: string): Promise<any> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  const response = await fetch(`${getApostatudoApiUrl()}${path}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      ...getApostatudoAuthHeaders(),
    },
    signal: controller.signal,
  }).finally(() => clearTimeout(timeoutId));

  if (!response.ok) {
    throw new Error(`Roulette API GET ${path} failed: ${response.status}`);
  }

  return response.json();
}

// Erro tipado do giro: o adapter só CLASSIFICA a falha; mensagem pro usuário e
// triagem de Sentry ficam na store, decididas pelo kind — nunca casando string
// de copy entre camadas.
// 'delivery_failed' = 502: falha ao creditar o prêmio; o giro foi ESTORNADO no
// back (usuário não perdeu o giro) — a UI mostra a mensagem e reabilita o botão.
export type RouletteSpinErrorKind =
  | 'network'
  | 'rate_limited'
  | 'delivery_failed'
  | 'api';

export class RouletteSpinError extends Error {
  constructor(
    public readonly kind: RouletteSpinErrorKind,
    message?: string,
  ) {
    super(message ?? kind);
    this.name = 'RouletteSpinError';
  }
}
